import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/register/add-employees/upload/page";

export const Route = createFileRoute("/auth/register/add-employees/upload")({
  component: Page,
});
